/**
 * Safe JSON Parsing with Error Handling
 */

import { errors } from "com";

const { SystemError } = errors;

/**
 * Parse JSON response safely
 * Detects empty responses and invalid JSON
 */
export async function parseJsonSafely<T>(response: Response): Promise<T> {
  const text = await response.text();

  if (!text) {
    throw new SystemError("Empty response from server");
  }

  try {
    return JSON.parse(text) as T;
  } catch (_error) {
    // Log in development only
    if (import.meta.env.DEV) {
      console.error("Invalid JSON response:", text);
    }
    throw new SystemError("Invalid response format from server");
  }
}
